import React from 'react';
import { Box, ButtonSwitchGroup, useTheme } from '@ublend-npm/aulaui-core';

export type CommonRoomTab = 'feed' | 'pinned';

interface CommonRoomTabsProps {
  activeTab: CommonRoomTab;
  pinnedCount?: number;
  onTabChange: (tab: CommonRoomTab) => void;
}

const tabs: CommonRoomTab[] = ['feed', 'pinned'];
const DARK_MODE_ACTIVE_TAB_TEXT_COLOR = 'rgba(35, 2, 84, 1)';

const CommonRoomTabs = ({
  activeTab,
  pinnedCount = 0,
  onTabChange,
}: CommonRoomTabsProps) => {
  const theme = useTheme();
  const activeIndex = Math.max(tabs.indexOf(activeTab), 0);
  const labels = ['Feed', `Pinned (${pinnedCount})`];

  const handleSelect = (index: number) => {
    const selectedTab = tabs[index];

    if (selectedTab && selectedTab !== activeTab) {
      onTabChange(selectedTab);
    }
  };

  return (
    <Box
      role="group"
      aria-label="Common Room post view"
      sx={{
        width: 152,
      }}
    >
      <ButtonSwitchGroup
        size="small"
        options={labels.map((label, index) => (
          <Box
            component="span"
            key={tabs[index]}
            sx={{
              whiteSpace: 'nowrap',
              ...(theme.palette.mode === 'dark' &&
                activeIndex === index && {
                  color: DARK_MODE_ACTIVE_TAB_TEXT_COLOR,
                }),
            }}
          >
            {label}
          </Box>
        ))}
        activeIndex={activeIndex}
        onSelect={handleSelect}
      />
    </Box>
  );
};

export default CommonRoomTabs;
